import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

window.addEventListener('load', (e) => {
	const gallerySwipers = document.querySelectorAll('.gallery-swiper');

	gallerySwipers.forEach((gallery) => {
		const gallerySwiper = new Swiper(gallery, {
			modules: [Navigation],
			spaceBetween: 20,
			slidesPerView: 1.1,
			// centeredSlides: true,
			loop: true,
			navigation: {
				nextEl: gallery.querySelector('.swiper-button-next'),
				prevEl: gallery.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				860: {
					slidesPerView: 2.2,
				},
				1160: {
					slidesPerView: 3,
				},
			},
		});
	});
});
